import React from 'react';
import { Link } from 'react-router-dom';

export default function PageEn() {
    return (
        <div className="page" style={{ alignItems:'center', justifyContent:'center', minHeight:'100vh' }}>
            <div style={{ textAlign:'center', padding:40 }}>
                <h2 style={{ color:'var(--color-dark)', marginBottom:30 }}>3rd Forum on Climate and Nature Finance</h2>
                <Link to="/" className="btn-send">Go to home</Link>
            </div>
        </div>
    );
}
